/*jshint esversion: 6 */
import Vue from 'vue';

const initialState = () => ({
//workbench local variables
  sequence_editor_variables: {
    search: '',
    statistic_settings: {
      value: 'workpackages',
      cumulative: false,
      filter: false,
      colors: [],
      icons: [],
    },
  },
  workbench_variables: {
    items_mini: false,
    search: '',
    loading: false,
    search_all: JSON.parse(localStorage.getItem('WORKBENCH_search_all_subfolders')) || false,
  },

//types:
//sequence
  sequence: {
    name: 'Your new Sequence',
    takt_time: {
      value: 5,
      unit: 'day',
      hashtag: 'TT5D'
    },
    country: 'none',
    swaggons: [],
    hashtags: [],
    updated: new Date().toISOString()
  },
//waggon
  waggon: {
    token: 'W0',
    country: 'none',
    wagworkpackages: [],
    hashtags: []
  },
//WorkPackage
  workpackage: {
    color: "red lighten-1",
    contact_email: "",
    contact_name: "",
    contact_phone_number: "",
    costs_budget_labour: 0,
    costs_budget_material: 0,
    costs_budget_total: 0,
    costs_only_total: false,
    country: "other",
    description: "",
    duration: 0,
    duration_actual: 0,
    hashtags: [],
    icon: "obj-drainage-pipe",
    is_community_suggested: false,
    manpower_actual: 0,
    manpower_planned: 0,
    name: "",
    order_index: 0,
    quantity_unit: "",
    quantity_value: 0,
    status: "none",
    tender_status: "false",
    textcolor: "black",
    time_effort_planned: 0,
    token: "",
    wworksteps: [],
    wdefectsteps: [],
    wqualitysteps: [],
    whandoversteps: [],
    wlogisticsteps: [],
    wdesignsteps: [],
    wmaterialsteps: [],
    wmachinesteps: [],
    wworkpackageimages: [],
  },
  //material
    material: {
      name: 'New Material',
      description: '',
      price: 0.,
      carbon_dioxide: 0.,
      height: 0.,
      length: 0.,
      width: 0.,
      weight: 0.,
      custom_id: '',
      price_source: '',
      carbon_dioxide_source: '',
      height_source: '',
      length_source: '',
      width_source: '',
      weight_source: '',
      country: 'none',
      propertysets: [],
      bsmaterialsteps: [],
      bwmaterialsteps: [],
      hashtags: []
    },

  // etc
  error: ''
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getWBLObject: (state) => (payload) => {
    let object = state;
    payload.path.forEach(entry => {
      if (Object.values(entry)[0] !== '') {
        object = object[Object.keys(entry)[0]][Object.values(entry)[0]];
      } else {
        object = object[Object.keys(entry)[0]];
      }
    });
    return object;
  },
  getAISequenceWaggonsLocal: (state) => (payload) => {
    let waggons = JSON.parse(JSON.stringify(state.sequence.swaggons));
    for (let i = 0; i < waggons.length; i++) {
      waggons[i].position = i + parseInt(1);
    }
    if (payload.complete_sequence) {
      return {
        sequence_id: payload.sequence_id,
        swaggons: waggons
      };
    } else {
      let index = payload.waggon_id;
      return {
        prev_waggon: index > 0? waggons[index-1]:{},
        curr_waggon: waggons[index],
        next_waggon: index < waggons.length-1?waggons[index+parseInt(1)]:{}
      };
    }
  }
};

// Actions
const actions = {
  createWBLObject({commit, getters}, payload){
    let object = getters.getWBLObject(payload);
    payload.object = object;
    commit('create_wbl_objects', payload);
  },
  updateWBLObject({commit, getters}, payload) {
    let object = getters.getWBLObject(payload);
    payload.object = object;
    commit('update_wbl_object', payload);
  },
  deleteWBLObject({commit, getters}, payload) {
    let object = getters.getWBLObject(payload);
    payload.object = object;
    commit('delete_wbl_object', payload);
  },
  resetWorkpackage({commit}) {
    commit('reset_workpackage');
  },
  resetSequence({commit}) {
    commit('reset_sequence');
  },
  resetWaggon({commit}) {
    commit('reset_waggon');
  },
  resetMaterial({commit}) {
    commit('reset_material');
  }
};

// Mutations
const mutations = {
  //object mutations
  create_wbl_objects(state, payload) {
    if (payload.wbl_object.position) {
      let position = payload.wbl_object.position;
      delete payload.wbl_object.position;
      payload.object.splice(position-1, 0, payload.wbl_object);
    } else {
      payload.object.push(payload.wbl_object);
    }
  },
  update_wbl_object(state, payload){
    // console.log(payload.object)
    Object.assign(payload.object, payload.update);
    // console.log(payload.object, "--------------")
    // console.log(state.workbench_variables)
  },
  delete_wbl_object(state, payload) {
    return new Promise((resolve) => {
      Vue.delete(payload.object, payload.index);
      resolve();
    });
  },
  reset_workpackage(state){
    state.workpackage = {
      color: "red lighten-1",
      contact_email: "",
      contact_name: "",
      contact_phone_number: "",
      costs_budget_labour: 0,
      costs_budget_material: 0,
      costs_budget_total: 0,
      costs_only_total: false,
      country: "other",
      description: "",
      duration: 0,
      duration_actual: 0,
      hashtags: [],
      icon: "obj-drainage-pipe",
      is_community_suggested: false,
      manpower_actual: 0,
      manpower_planned: 0,
      name: "",
      order_index: 0,
      quantity_unit: "",
      quantity_value: 0,
      status: "none",
      tender_status: "false",
      textcolor: "black",
      time_effort_planned: 0,
      token: "",
      wworksteps: [],
      wdefectsteps: [],
      wqualitysteps: [],
      whandoversteps: [],
      wlogisticsteps: [],
      wdesignsteps: [],
      wmaterialsteps: [],
      wmachinesteps: [],
      wworkpackageimages: [],
    };
  },
  reset_sequence(state){
    state.sequence = {
      name: 'Your new Sequence',
      takt_time: {
        value: 5,
        unit: 'day',
        hashtag: 'TT5D'
      },
      country: 'none',
      swaggons: [],
      hashtags: []
    };
  },
  reset_waggon(state){
    state.waggon = {
      token: 'W0',
      country: 'none',
      wagworkpackages: [],
      hashtags: []
    };
  },
  reset_material(state){
    state.material = {
      name: 'New Material',
      description: '',
      price: 0.,
      carbon_dioxide: 0.,
      height: 0.,
      length: 0.,
      width: 0.,
      weight: 0.,
      custom_id: '',
      price_source: '',
      carbon_dioxide_source: '',
      height_source: '',
      length_source: '',
      width_source: '',
      weight_source: '',
      country: 'none',
      propertysets: [],
      bsmaterialsteps: [],
      bwmaterialsteps: [],
      hashtags: []
    };
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
